import React, { useState } from 'react'
import PropTypes from 'prop-types'
import FlipMove from 'react-flip-move'
import { useSwipeable } from 'react-swipeable'

import HeaderBlock from '../../primitives/HeaderBlock'

import InfCard from './primitives/InfCard'
import Arrow from './primitives/Arrow'

import {
  Wrapper,
  CardsWrapper,
  Controller,
  ArrowWrapper,
} from './InfiniteCards.styles'

const InfiniteCards = ({
  cards,
  headerText,
  subText,
  pad,
  cardHeight,
  activeCardHeight,
  cardWidth,
  activeCardWidth,
}) => {
  const [list, setList] = useState(cards)
  const [isAnimatingForward, setAnimatingForward] = useState(false)
  const [activeId, setActiveId] = useState(
    cards[Math.floor(cards.length / 2)].id
  )
  const activeIndex = Math.floor(cards.length / 2)
  const isActive = (id) => {
    return id === activeId
  }

  const [remountCount, setRemountCount] = useState(0)
  const refresh = () => setRemountCount(remountCount + 1)
  const handleNext = () => {
    let currCards = list
    currCards.push(currCards.shift())
    setList(currCards)
    setAnimatingForward(true)
    refresh()
  }

  const handlePrev = () => {
    let currCards = list
    currCards.unshift(currCards.pop())
    setList(currCards)
    setAnimatingForward(false)
    refresh()
  }

  const handleMove = (index) => {
    if (index !== activeIndex) {
      setTimeout(() => {
        setActiveId(list[Math.floor(cards.length / 2)].id)
      }, 300)
      return index > activeIndex ? handleNext : handlePrev
    }
  }

  const handlers = useSwipeable({
    onSwipedRight: handlePrev,
    onSwipedLeft: handleNext,
  })

  return (
    <Wrapper
      activeCardHeight={activeCardHeight}
      activeCardWidth={activeCardWidth}
    >
      <HeaderBlock
        headerText={headerText}
        subText={subText}
        bgColor="transparent"
        pad={pad}
      />
      <CardsWrapper {...handlers} isAnimatingForward={isAnimatingForward}>
        <FlipMove typeName={null} duration={1100}>
          {list.map((card, i) => (
            <div key={card.id}>
              <InfCard
                head={card.head}
                icon={card.icon}
                sub={card.sub}
                cName={i === activeIndex ? 'active' : ''}
                isActive={isActive(card.id)}
                handleMove={handleMove(i)}
                cardHeight={cardHeight}
                cardWidth={cardWidth}
              />
            </div>
          ))}
        </FlipMove>
      </CardsWrapper>
      <Controller>
        <ArrowWrapper onClick={handlePrev}>
          <Arrow />
        </ArrowWrapper>
        <ArrowWrapper className="right" onClick={handleNext}>
          <Arrow right />
        </ArrowWrapper>
      </Controller>
    </Wrapper>
  )
}

InfiniteCards.defaultProps = {
  headerText: 'How it Works',
  subText: null,
  pad: '10rem 0 4rem',
}

InfiniteCards.propTypes = {
  cards: PropTypes.arrayOf(PropTypes.object).isRequired,
  headerText: PropTypes.string,
  subText: PropTypes.element,
  pad: PropTypes.string,
}

export default InfiniteCards
